// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimInternalNoteResponseDto
 */
export interface IClaimInternalNoteResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimInternalNoteResponseDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimInternalNoteResponseDto
     */
    claim_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimInternalNoteResponseDto
     */
    note_text?: string;
    /**
     * 
     * @type {Date}
     * @memberof IClaimInternalNoteResponseDto
     */
    added_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IClaimInternalNoteResponseDto
     */
    updated_at?: Date;
    /**
     * 
     * @type {number}
     * @memberof IClaimInternalNoteResponseDto
     */
    contact_id?: number;
}

/**
 * Check if a given object implements the IClaimInternalNoteResponseDto interface.
 */
export function instanceOfIClaimInternalNoteResponseDto(value: object): value is IClaimInternalNoteResponseDto {
    return true;
}

export function IClaimInternalNoteResponseDtoFromJSON(json: any): IClaimInternalNoteResponseDto {
    return IClaimInternalNoteResponseDtoFromJSONTyped(json, false);
}

export function IClaimInternalNoteResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimInternalNoteResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'note_text': json['note_text'] == null ? undefined : json['note_text'],
        'added_at': json['added_at'] == null ? undefined : (new Date(json['added_at'])),
        'updated_at': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'contact_id': json['contact_id'] == null ? undefined : json['contact_id'],
    };
}

export function IClaimInternalNoteResponseDtoToJSON(json: any): IClaimInternalNoteResponseDto {
    return IClaimInternalNoteResponseDtoToJSONTyped(json, false);
}

export function IClaimInternalNoteResponseDtoToJSONTyped(value?: IClaimInternalNoteResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'claim_id': value['claim_id'],
        'note_text': value['note_text'],
        'added_at': value['added_at'] == null ? undefined : ((value['added_at']).toISOString()),
        'updated_at': value['updated_at'] == null ? undefined : ((value['updated_at']).toISOString()),
        'contact_id': value['contact_id'],
    };
}

